// src/components/parent-dashboard/modals/LinkChildModal.js
import React, { useRef, useEffect } from "react";

/**
 * Modal for linking a child to parent account
 */
const LinkChildModal = ({ isOpen, onClose, linkEmail, setLinkEmail, handleLinkChild, loading }) => {
    const inputRef = useRef(null);

    // when the modal opens, focus the input
    useEffect(() => {
        if (isOpen) {
            inputRef.current?.focus();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
                className="absolute inset-0 bg-black opacity-50"
                onClick={onClose}
            />
            <div className="bg-white rounded-lg shadow-xl z-10 p-6 w-full max-w-md">
                <h2 className="text-xl font-bold mb-4">Link a Child</h2>
                <form onSubmit={e => {
                    e.preventDefault();
                    handleLinkChild();
                }}>
                    <label htmlFor="childEmail" className="block mb-1 font-medium">
                        Child's Email
                    </label>
                    <input
                        ref={inputRef}
                        id="childEmail"
                        type="email"
                        autoFocus
                        value={linkEmail}
                        onChange={e => setLinkEmail(e.target.value)}
                        className="w-full border px-3 py-2 rounded mb-4"
                        placeholder="student@example.com"
                    />
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 border rounded"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-[#2173B7] text-white rounded"
                            disabled={loading}
                        >
                            {loading ? "Linking…" : "Link Child"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LinkChildModal;